import styled from "styled-components";
import { transparentize } from "polished";

import { H4 } from "components/Text";
import theme from "config/theme";

export const Wrapper = styled.a`
  display: block;
  padding: 50px 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  cursor: pointer;
  box-shadow: 0 1px 4px 0 ${transparentize(0.95, theme.color.gray2)},
    0 3px 25px 0 ${transparentize(0.92, theme.color.gray2)};
  border-radius: ${theme.radius};
  background-color: white;

  @media (max-width: ${theme.size.mobile}) {
    padding: 35px 10px;
  }

  &:hover {
    box-shadow: 0 2px 5px 0 ${transparentize(0.92, theme.color.gray2)},
      0 8px 35px 0 ${transparentize(0.8, theme.color.gray2)};
  }
`;

export const Title = styled(H4)`
  line-height: 1.4;
  margin-bottom: 15px;
  font-weight: ${theme.font.weight.regular};
`;

export const Location = styled.p`
  margin: 0;
  color: ${theme.color.gray4};
`;
